module.exports = __webpack_public_path__ + "img/Group 2.1c151e03.png";